import { Navigate, useSearchParams } from 'react-router-dom';

import { safeReturnTo } from './returnTo';

/**
 * Terminal redirect rendered after login + onboarding complete.
 * Reads `?returnTo=` from the URL and navigates there, falling back
 * to `/dashboard` when the param is missing or unsafe.
 */
export function PostAuthRedirect() {
  const [searchParams] = useSearchParams();
  const destination = safeReturnTo(searchParams.get('returnTo'));
  return <Navigate to={destination} replace />;
}
